import styled from '@emotion/styled/macro';
import rem from '../../utils/rem/rem';

export const TableRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: ${rem(16)};
  gap: ${rem(16)} 40px;
  padding-top: ${rem(16)};

  @media ${({ theme }) => theme.breakpoints.md} {
    flex-direction: column;
  }
`;

export const TableWrapper = styled.div`
  width: calc(50vw - 144px);
  flex-grow: 1;

  @media ${({ theme }) => theme.breakpoints.md} {
    width: 100%;
  }
`;
